var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs12":""}},[_c('UiHeader',{attrs:{"title":"Atualizar Meus Dados"}})],1),_c('UpdateCurrentUserForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }